/* eslint-disable no-irregular-whitespace */
import React, { useState, useEffect, useRef, useContext } from 'react';
import { Content, CreateButton, FilterButton } from './style';
import { LeftSide, OptionsButton, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv, RefreshIcon, FilterWrapper } from '../../../components/styles/subheader-style';
import { Filter as FilterIcon } from 'lucide-react'
import FilterMenu from '../../../components/SubHeaderFilter/FilterMenu'
import AppliedFiltersDisplay from '../../../components/SubHeaderFilter/AppliedFiltersDisplay'
import { Filter, Header } from '../../../components/SubHeaderFilter/types'
import Plus from '../../../assets/production-flow/whiteplus.svg'

import { Outlet, useLocation, useNavigate, useOutletContext, useMatch } from 'react-router-dom';
import { TypeMainOutlet } from '..';
import movement from '../../../assets/stock/TableMovementHeader/refresh-active.svg';
import timeFast from '../../../assets/production-flow/time-fast.svg';
import FieldsManager, { FieldsManagerType } from '../../../components/FieldManager';
import { tableFields } from '../../../components/FieldManager/table-fields';
import WithoutSelectedFields from '../../SystemErrors/WithoutSelectedFields';
import LoadMoreButton from '../../../components/LoadMoreButton';
import arrow from '../../../assets/stock/LoadMoreButton/arrow-down.svg';
import filter from '../../../assets/stock/TableMovementHeader/filter.svg';
import refresh_act from '../../../assets/refresh-active.svg';
import TableFiltersContext from '../../../contexts/TableFiltersContext';
import SectionContext from '../../../contexts/SectionContext';
import { FilterTypesDiv, CompanyTypes } from '../../../components/Stock/TableMovementHeader/style';
import FiltersHeader from '../../../components/Stock/FiltersHeader';
import FiltersMenu from '../../../components/Stock/TableMovementHeader/FiltersMenu';

export interface ProductionOutletType {
  selectedStage: number;
  setSelectedStage: React.Dispatch<React.SetStateAction<number>>;
  tabIndex: number;
  setTabIndex: React.Dispatch<React.SetStateAction<number>>;
  search: string;
  fields: FieldsManagerType;
  setIsDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>;
  quantity: number;
  setQuantity: React.Dispatch<React.SetStateAction<number>>;
  refresh: boolean;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  appliedFilters: Filter[]
}

const TAB_INDEX_PRODUCTION = 0;
const TAB_INDEX_MOVEMENT = 1;

const tabs = [
  { path: '/panel/production', image: timeFast, name: 'Ordem de produção', index: TAB_INDEX_PRODUCTION },
  { path: '/panel/production/movement', image: movement, name: 'Movimentação', index: TAB_INDEX_MOVEMENT },
];

const ProductionFlow = () => {
  const navigate = useNavigate();
  const movementMatch = useMatch('/panel/production/movement');
  const createMatch = useMatch('/panel/production/create');
  const editMatch = useMatch('/panel/production/edit/:id');
  const [isdropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedStage, setSelectedStage] = useState<number>(1);
  const { search } = useOutletContext<TypeMainOutlet>();
  const fromLocalStorage = localStorage.getItem('tableFields');
  const [quantity, setQuantity] = useState(10);
  const [refresh, setRefresh] = useState(false);
  const { movementFilters } = useContext(TableFiltersContext);
  const { stockSection } = useContext(SectionContext);
  const location = useLocation();

  const companyTypesIds = ['Pedido', 'Manual'];
  const { movementTypeFilter, setMovementTypeFilter } = useContext(TableFiltersContext);
  const [isFiltersMenuOpen, setIsFiltersMenuOpen] = useState<boolean>(false);
  const filterMenuRef = useRef<HTMLDivElement>(null);
  const filterDropdownRef = useRef<HTMLDivElement>(null);

  const tabIndex = movementMatch ? TAB_INDEX_MOVEMENT : TAB_INDEX_PRODUCTION;

  const isCreateOrEditPage = createMatch || editMatch;

  const [fields, setFields] = useState<FieldsManagerType | undefined>(() => {
    const tableFieldsFromLocalStorage: FieldsManagerType[] = fromLocalStorage ? JSON.parse(fromLocalStorage) : tableFields;
    const currentSection = tabIndex === 1 ? 'movement' : 'stock';
    const foundFields = tableFieldsFromLocalStorage.find(field => field.tableSection === currentSection);
    const defaultFromTable = tableFields.find(field => field.tableSection === currentSection);
    

    return (foundFields && foundFields.whichFieldsToShow.some(field => field.checked)) 
      ? foundFields 
      : defaultFromTable;
  });

  const tableFieldsJson: FieldsManagerType[] = fromLocalStorage ? JSON.parse(fromLocalStorage) : tableFields;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterMenuRef.current &&
        filterDropdownRef.current &&
        !filterMenuRef.current.contains(event.target as Node) &&
        !filterDropdownRef.current.contains(event.target as Node)
      ) {
        setIsFiltersMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!fields) return;
    const toLocalStorage = tableFieldsJson.map((table: FieldsManagerType) => {
      const currentSection = tabIndex === 1 ? 'movement' : 'stock';
      if (table.tableSection === currentSection) {
        return { ...table, whichFieldsToShow: fields.whichFieldsToShow };
      }
      return table;
    });
    localStorage.setItem('tableFields', JSON.stringify(toLocalStorage));
  }, [fields, tabIndex]);

  useEffect(() => {
    const currentSection = tabIndex === 1 ? 'movement' : 'stock';
    const foundFields = tableFieldsJson.find(field => field.tableSection === currentSection);
    const defaultFromTable = tableFields.find(field => field.tableSection === currentSection);
    

    const fieldsToUse = (foundFields && foundFields.whichFieldsToShow.some(field => field.checked)) 
      ? foundFields 
      : defaultFromTable;
      
    if (fieldsToUse) {
      setFields(fieldsToUse);
    }
  }, [tabIndex]);

  const handleSetTypes = (id: string) => {
    if (movementTypeFilter.includes(id)) {
      if (movementTypeFilter.split(',').length === 1) {
        return;
      }
      setMovementTypeFilter(
        movementTypeFilter
          .split(',')
          .filter((item) => item !== id)
          .join(',')
      );
    } else {
      setMovementTypeFilter(movementTypeFilter ? `${movementTypeFilter},${id}` : id);
    }
  };

  const handleButtonCreate = () => {
    navigate('/panel/production/create');
  };

  if (!fields) {
    return null;
  }

  return (
    <>
      {!isCreateOrEditPage && (
        <>
          <SubHeaderContainer>
            <LeftSide>
              <SectionName>Produção</SectionName>
              <TabsDiv>
                {tabs.map((tab) => (
                  <Tab
                    key={tab.index}
                    $isFirst={tab.index === 0}
                    $isLast={tab.index === tabs.length - 1}
                    $isActive={tab.index === tabIndex}
                    onClick={() => navigate(tab.path)}
                  >
                    <img src={tab.image} alt={`${tab.path}-icon`} />
                    {tab.name}
                  </Tab>
                ))}
              </TabsDiv>
            </LeftSide>
            <RightSide>
              <div ref={filterMenuRef}>
                <FilterButton onClick={() => setIsFiltersMenuOpen(!isFiltersMenuOpen)}>
                  <img src={filter} alt="filter-icon" />
                  Filtrar
                </FilterButton>
              </div>
              {isFiltersMenuOpen ? <FiltersMenu ref={filterDropdownRef} anchorRef={filterMenuRef} /> : null}
              
            <CreateButton onClick={handleButtonCreate}>
                <img src={Plus} alt="plus-icon" />
                Ordem de produção
              </CreateButton>
              
              {tabIndex === 1 ? (
                <FilterTypesDiv>
                  {companyTypesIds.map((item) => (
                    <CompanyTypes
                      key={item}
                      className={movementTypeFilter.includes(item) ? 'actived' : ''}
                      onClick={() => handleSetTypes(item)}
                    >
                      {item}
                    </CompanyTypes>
                  ))}
                </FilterTypesDiv>
              ) : null}
            </RightSide>
          </SubHeaderContainer>
          {stockSection === 'movement' && movementFilters.length > 0 ? <FiltersHeader /> : null}
        </>
      )}
      
      <Content>
        {isdropdownOpen ? <FieldsManager dropdownOpen={setIsDropdownOpen} fields={fields} setFields={setFields as React.Dispatch<React.SetStateAction<FieldsManagerType>>} /> : null}
        {fields.whichFieldsToShow.filter((field) => field.checked).length === 0 ? (
          <WithoutSelectedFields dropdown={setIsDropdownOpen} />
        ) : (
          <Outlet
            context={{
              selectedStage,
              setSelectedStage,
              tabIndex,
              setTabIndex: () => {},
              search,
              fields,
              setIsDropdownOpen,
              quantity,
              setQuantity,
              refresh,
              setRefresh,
            }}
          />
        )}
      </Content>
    </>
  );
};

export default ProductionFlow;